import React from 'react';
import { SEO } from '../components/SEO';
import { HomePageSchema } from '../components/SchemaMarkup';
import { HeroNew } from '../components/HeroNew';
import { FeaturesSection } from '../components/FeaturesSection';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { CoreValues } from '../components/CoreValues';
import { SolutionsGrid } from '../components/SolutionsGrid';
import { BenefitsGrid } from '../components/BenefitsGrid';
import { Testimonials } from '../components/Testimonials';
import { Affiliations } from '../components/Affiliations';
import { ProudSupporter } from '../components/ProudSupporter';

export const HomePage = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="Medical Billing & Credentialing"
        description="Capital Billing Services provides medical billing, credentialing and revenue cycle management for healthcare practices nationwide. Request a free consultation."
        keywords="medical billing services, healthcare billing, credentialing services, revenue cycle management, medical practice management, Atlanta medical billing"
        canonicalUrl="/"
      />
      <HomePageSchema />
      <HeroNew />
      <FeaturesSection />
      <WhyChooseUs />
      <CoreValues />
      <SolutionsGrid />
      <BenefitsGrid />
      <Testimonials />
      <Affiliations />
      <ProudSupporter />
    </div>
  );
};
